import {
  Link,
  NavLink,
  Outlet,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import "./App.css";
import { useSelector, useDispatch } from "react-redux";
import { Sidebar, MobileBottomBar } from "@/components";
import { SidebarMenu } from "./utils/Data";
import NotificationSideBar from "./pages/Notification/Notification";
import { logoutUser } from "./app/Slices";
import { useEffect } from "react";
import { disconnectSocket, initializeSocket } from "./services/websocket";
import store from "./app/store";
import { logo } from "./assets/img";

function App() {
  // Get the user object from the Redux store
  const user = useSelector((state) => state.user.user) || {};
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Initialize socket only when user is logged in
  useEffect(() => {
    if (user) {
      // Initialize socket connection
      initializeSocket(store);
    }

    // Clean up socket connection when component unmounts
    return () => {
      disconnectSocket();
    };
  }, [user]); // Re-initialize if user ID changes

  // Handle logout
  const handleLogout = async () => {
    const resultAction = await dispatch(logoutUser());
    if (logoutUser.fulfilled.match(resultAction)) {
      // Optionally, clear any local storage or other client-side tokens if needed.
      navigate("/login");
    } else {
      // Handle the error case, e.g. show a notification
      console.error("Action:", resultAction);
      console.error("Logout failed:", resultAction.payload);
    }
  };

  return (
    <div className="w-full relative flex h-dvh gap-2 bg-background">
      {/* Sidebar */}
      <Sidebar
        sidebarMenus={SidebarMenu}
        user={{ name: user.name || "------", email: user.email || "------" }}
        logo={logo}
        Link={Link}
        NavLink={NavLink}
        useLocation={useLocation}
        NotificationLayout={NotificationSideBar}
        handleLogout={handleLogout} // Pass the logout function to the Sidebar
        showWalletBalance={false}
      />
      {/* Main Content */}

      <div className="w-full h-full flex justify-start overflow-y-auto">
        <Outlet />
      </div>
      {/* Mobile Bottom Bar */}
      <MobileBottomBar
        MenuItems={SidebarMenu}
        NotificationLayout={NotificationSideBar}
        handleLogout={handleLogout} // Pass the logout function to the Sidebar
        NavLink={NavLink}
        useLocation={useLocation}
      />
    </div>
  );
}

export default App;
